<script>
import { cloneDeep } from "lodash";
import BidActivityModal from "@/components/modals/bid-activity.vue"
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import UniqueReports from "@/components/widgets/bidding-unique-reports.vue"
import Swal from "sweetalert2";
import RawData from "@/components/widgets/raw-data.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import { required } from "vuelidate/lib/validators";

export default {
    props: {
        rfqs: {
            type: Array,
            default: () => []
        },
        headers: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false,
        },
        filter: null,
        perPage: Number,
    },
    components: {
        BidActivityModal,
        RawData,
        AttachmentModal,
        UniqueReports,
        PrintOptions
    },
    validations: {
        description: {required},
        // tracking: {required},
        deadline: {required},
        dateSubmitted: {required},
    },
    data(){
        return{
            selectedPR: null,
            selectedRFQ: null,
            modalTitle: null,
            modalHeader: null,
            modalSubheader: null,
            currentPage: 1,
            submitted: false,
            rfq: {
                id: 0,
                prId: null,
                description: null,
                // tracking: null,
                deadline: null,
                note: null,
                dateSubmitted: null,
            },
            filteredHeader: []
        }
    },
    computed: {
        filteredTable() {
            let data = this.rfqs;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.searchKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data;
        },
    },
    methods: {
        hasThisActivity(head, arr){
            let result = arr.find(x => x.bidActivityId == head.id);
            return result;
        },
        createNewActivity(rfq, head){
            if(!rfq){
                return this.showToast('Create Bid For Sale first!', 'warning');
            }
            this.selectedRFQ = rfq;
            let ids = rfq.activities.map(item => item.bidActivityId);
            let filteredHeader = [];
            this.headers.map(item => {
                if(!ids.includes(item.id)){
                    filteredHeader.push(item);
                }
            })
            this.filteredHeader = filteredHeader;
            this.$refs.bidActModal.updateData({
                id: 0,
                rfqId: rfq.id,
                bidActivityId: head.id,
                bidActivity: head,
                schedule: "",
                notes: "",
                mode: "",
            })
            this.modalTitle = "Add Activity";
            this.$bvModal.show("activity-modal");
        },
        onSubmitActivity(modalData){
            let data = cloneDeep(modalData);
            data.schedule = this.getDate(modalData.schedule);
            data.preEventNotification = this.getDate(modalData.preEventNotification);
            if(modalData.id == 0){
                this.$store
                    .dispatch("bidactivityschedule/CreateBidActivitySchedule", data)
                    .then(async (res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.selectedRFQ.activities.push(res.data);
                        this.$bvModal.hide("activity-modal");
                        this.showToast("Activity saved!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong! - saving activity", "error");
                    });
            }else{
                this.$store
                    .dispatch("bidactivityschedule/UpdateBidActivitySchedule", data)
                    .then(async (res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.selectedRFQ.activities.findIndex(x => x.id == modalData.id);
                        this.selectedRFQ.activities.splice(index, 1, data);
                        this.$bvModal.hide("activity-modal");
                        this.showToast("Activity updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong! - saving activity", "error");
                    });
            }
        },
        updateBidSchedule(activity, parent){
            this.selectedPR = parent;
            let data = cloneDeep(activity);
            data.prId = parent.id;
            data.schedule = new Date(activity.schedule);
            this.$refs.bidActModal.updateData(data);
            this.modalTitle = "Update Activity";
            this.$bvModal.show("activity-modal");
        },
        deleteBidSchedule(activity, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("bidactivityschedule/DeleteBidActivitySchedule", activity.id)
                        .then(async (res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let index = parent.activities.findIndex(x => x.id == activity.id);
                            parent.activities.splice(index, 1);
                            this.showToast("Activity deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast(
                                "Something went wrong! - deleting activity",
                                "error"
                            );
                        });
                }
            });
        },
        createRfq(pr){
            this.$emit('createRfq', pr);
        },
        async getAttachments(activity, parent){
            this.$refs.attachmentModal.setUploadOpt({
                type: "Bid Activity",
                placement: "left",
                folder: "Procurement",
            });
            this.modalHeader = `Project Name: ${parent.description}`;
            this.modalSubheader = `${activity.activityName}`;
            this.$bvModal.show("upload-attachment-modal");
            await this.$refs.attachmentModal.getData(activity.id);
            
        },
        async generateUR(id){
            
        },
        async uploadForUR(parent, act, actReport){
            this.$refs.attachmentModal.setUploadOpt({
                type: `BAct URep ${act.activityName} ${parent.id}`,
                placement: "left",
                folder: "Procurement",
            });
            this.modalHeader = `Project Name: ${parent.description}`;
            this.modalSubheader = `${act.activityName} (${actReport.reportType})`;
            this.$bvModal.show("upload-attachment-modal");
            await this.$refs.attachmentModal.getData(actReport.id);
        },
        async generateNotice(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/NoticeOfMeeting",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printInvitation(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/InvitationToBid",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printInstruction(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/InstructionToBidders",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printDataSheet(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/BidDataSheet",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printGeneralContract(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/GeneralConditionsOfContract",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printSpecialContract(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/SpecialConditionsOfContract",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printSchedReq(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/ScheduleOfRequirements",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printChecklist(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/ChecklistOfTechnicalAndFinancialDocuments",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        printSchedules(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "procurement/PublicBidding/Generate/ScheduleOfBiddingActivities",
                routeVariables: [id],
                body: []
            });
            this.$bvModal.show("print-options-modal");
        },
        titleName(act){
            if(act.activityName.toLowerCase().includes('pre-proc')){
                return `Generate Notice of Meeting & MEMO`;
            }
            if(act.activityName.toLowerCase().includes('posting')){
                return `Generate Bidding Documents`;
            }
            if(act.activityName.toLowerCase().includes('pre-bid')){
                return `Generate Notice of Bidding Activities`;
            }
            if(act.activityName.toLowerCase().includes('notice of award')){
                return `Generate NOA & Indorsement`;
            }
            if(act.activityName.toLowerCase().includes('notice to proceed')){
                return `Generate NTP & Indorsement`;
            }
            return `Generate Notice of Meeting`;
        },
        async getBidActivities(rfq){
            try{
                const { data: response } = await this.$store.dispatch("bidactivityschedule/GetBidActivityScheduleByRfq", rfq.id);
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                rfq.activities = response;
            }catch(err){
                console.log(err);
                this.showToast("Something went wrong! - fetching activities", "error");
            }
        },
    }
}
</script>
<template>
    <div>
        <template v-if="loading">
            <div class="d-flex mb-1" style="gap:5px;">
                <b-skeleton width="400px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
                <b-skeleton width="180px" height="100px" class="bg-primary bg-soft"></b-skeleton>
            </div>
            <div class="d-flex mb-1" style="gap:5px;" v-for="n in 5" :key="n">
                <b-skeleton width="100%" height="100px" class="bg-primary bg-soft"></b-skeleton>
            </div>
        </template>
        <template v-else>
            <div class="table-container">
                <table class="table table-bordered sticky-table">
                    <thead>
                        <tr>
                            <th style="width: 300px;height:90px" class="sticky-th stick-header p-0 text-center" >
                                <div class="d-flex align-items-center px-3 h-100 border">
                                    Project
                                </div>
                            </th>
                            <template v-for="x in headers">
                                <th :key="x.id" style="width: 210px;" class="stick-header">{{x.activityName}}</th>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!rfqs.length">
                            <td colspan="100%">No data found.</td>
                        </tr>
                        <tr v-if="!filteredTable.length && rfqs.length">
                            <td colspan="100%">Search not found.</td>
                        </tr>
                        <template v-if="rfqs.length">
                            <tr v-for="y in filteredTable" :key="y.id">
                                <td class="sticky-th p-0">
                                    <RawData :data="y" />
                                    <div class="p-3">
                                        {{y.description}}
                                        <div>
                                            <small class="text-warning" v-if="y.deliveryUnit">[{{y.deliveryUnit}}]</small>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <button class="btn btn-sm btn-purple mt-1" type="button" :id="`Act${y.id}`"><i class="bx bx-printer me-1"></i>Bid Reports</button>
                                            <b-popover
                                                :target="`Act${y.id}`"
                                                triggers="click blur"
                                                custom-class="p-0 p-custom-class"
                                                placement="center bottom"
                                            >
                                                <b-list-group class="w-100 fit">
                                                    <b-list-group-item button action @click="printInvitation(y.id)">
                                                        Invitation
                                                    </b-list-group-item>
                                                    <b-list-group-item button action @click="printInstruction(y.id)">
                                                        Instruction to Bidders
                                                    </b-list-group-item>
                                                    <b-list-group-item button action @click="printDataSheet(y.id)">
                                                        Data Sheet
                                                    </b-list-group-item>
                                                    <b-list-group-item button action @click="printGeneralContract(y.id)">
                                                        General Conditions of Contract
                                                    </b-list-group-item>
                                                    <b-list-group-item button action @click="printSpecialContract(y.id)">
                                                        Special Conditions of Contract
                                                    </b-list-group-item>
                                                    <b-list-group-item button action @click="printSchedReq(y.id)">
                                                        Schedule of Requirements
                                                    </b-list-group-item>
                                                    <b-list-group-item button action @click="printChecklist(y.id)">
                                                        Checklist of Technical and Financial Documents
                                                    </b-list-group-item>
                                                    <b-list-group-item button action @click="printSchedules(y.id)">
                                                        Schedule of Bidding Activities
                                                    </b-list-group-item>
                                                </b-list-group>
                                            </b-popover>
                                            <button 
                                                type="button" 
                                                class="btn btn-sm btn-warning mt-1" 
                                                v-if="!y.activities || y.activities.length == 0" 
                                                title="Show Activities" 
                                                @click="getBidActivities(y)"
                                            ><i class="bx bx-receipt me-1"></i></button>
                                        </div>
                                    </div>
                                </td>
                                <template v-for="x in headers">
                                    <template v-if="hasThisActivity(x, y.activities)">
                                        <td :key="`A${y.id}-B${x.id}`" class="text-center vertical-middle overflow-hidden">
                                            <div>
                                                {{ formatDateShortWTime(new Date(hasThisActivity(x, y.activities).schedule)) }}
                                                <a href="javascript:void(0)" @click="generateNotice(hasThisActivity(x, y.activities).id)" :title="titleName(x)">
                                                    <i class="bx bx-printer"></i>
                                                </a>
                                            </div>
                                            <small class="text-yellow d-block">[{{hasThisActivity(x, y.activities).mode}}] </small>
                                            <small>{{hasThisActivity(x, y.activities).notes}}</small>
                                            <small v-if="hasThisActivity(x, y.activities).onlineLink" >
                                                <a 
                                                    :href="hasThisActivity(x, y.activities).onlineLink"
                                                    class="text-ellipsis"
                                                    target="_blank"
                                                >
                                                    {{hasThisActivity(x, y.activities).onlineLink}}
                                                </a>
                                            </small>
                                            <div class="mt-1">
                                                <a href="javascript:void(0);" :id="`Bid${x.id}-Act${y.id}`"  class="border rounded px-2"><i class="bx bx-dots-horizontal-rounded"></i></a>
                                                <b-popover
                                                    :target="`Bid${x.id}-Act${y.id}`"
                                                    triggers="click blur"
                                                    custom-class="p-0 p-custom-class"
                                                    placement="center bottom"
                                                >
                                                    <b-list-group class="w-100 fit">
                                                        <b-list-group-item button action @click="updateBidSchedule(hasThisActivity(x, y.activities), y)">
                                                            <i class="bx bx-edit align-middle me-2 font-size-16"></i>
                                                            <span class="align-middle">Edit</span>
                                                        </b-list-group-item>

                                                        <b-list-group-item button action @click="deleteBidSchedule(hasThisActivity(x, y.activities), y)">
                                                            <i class="bx bx-trash align-middle me-2 font-size-16 text-danger"></i>
                                                            <span class="align-middle text-danger">Delete</span>
                                                        </b-list-group-item>

                                                        <b-list-group-item button action @click="getAttachments(hasThisActivity(x, y.activities), y)">
                                                            <i class="bx bx-paperclip align-middle me-2 font-size-16 text-warning"></i>
                                                            <span class="align-middle text-warning">Attachments</span>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </b-popover>
                                            </div>
                                            <small>
                                                <UniqueReports 
                                                    :prId="y.id"
                                                    :data="hasThisActivity(x, y.activities).bidActivityReports"
                                                    @generateReport="generateUR"
                                                    @uploadAttachment="uploadForUR(y, hasThisActivity(x, y.activities), $event)"
                                                />
                                            </small>
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td :key="`A${y.id}-B${x.id}`" class="hover-striped cursor-pointer" @click="createNewActivity(y, x)"></td>
                                    </template>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div
                v-if="filteredTable.length"
                class="dataTables_paginate paging_simple_numbers float-end mt-4"
            >
                <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="filteredTable.length"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </template>
        <BidActivityModal 
            ref="bidActModal" 
            @dropData="onSubmitActivity" 
            :modalTitle="modalTitle"
            :bidActivities="filteredHeader"
            :showAct="false"
        />
        <AttachmentModal
            :wActions="true"
            title="Bid Activity Attachments"
            ref="attachmentModal"
            :header="modalHeader"
            :subheader="{title: modalSubheader, class: 'text-warning'}"
        />
        <print-options ref="printOpt"></print-options>
    </div>
</template>

<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>